import { store } from '@wordpress/interactivity';

const lightbox = GLightbox({
    width: '90%',
    height: '90%',
});

const isMobile = (
    /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    ('ontouchstart' in window && window.matchMedia("(max-width: 1024px)").matches)
);

store('gt-fse-documents', {
    actions: {
        openLightbox: (event) => {
            if (!event.currentTarget) {
                console.error('currentTarget est null.');
                return;
            }

            const button = event.currentTarget;
            const fileUrl = button.dataset.file;

            if (!fileUrl) {
                console.error('Aucun fichier associé.');
                return;
            }

            if (isMobile) {
                window.location.href = fileUrl;
                return;
            }

            lightbox.setElements([
                {
                    'href': fileUrl,
                    'type': 'external',
                    'width': '1000px',
                    'height': '90vh',
                }
            ]);
            lightbox.open();
        },
    },
});
